import { render, staticRenderFns } from "./detailedLote.vue?vue&type=template&id=0b7f2a70"
import script from "./detailedLote.vue?vue&type=script&lang=js"
export * from "./detailedLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports